import { to_var } from "../utils/to_var";

// JSON Serializable
function to_json_serializable_var(key, var_name, var_type) {
  return {
    _class: `\n\t@JsonKey(name: '${key}')\n\tfinal ${var_type} ${var_name};\n`,
    _builder: `this.${var_name}`
  };
}

export function jsonSerializableParser(class_name, value) {
  let _type = "";
  let _classes = [];
  let _variable_name;
  let _class_name;
  let _default;

  try {
    _variable_name = to_var(class_name);
    _class_name = to_var(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "String";
    _default = '""';
  } else if (typeof value === "string") {
    _type = "String";
    _default = '""';
  } else if (typeof value === "boolean") {
    _type = "bool";
    _default = "true";
  } else if (typeof value === "number") {
    if (value % 1 === 0) {
      _type = "int";
      _default = "0";
    } else {
      _type = "double";
      _default = "0.0";
    }
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "List<String>";
        _default = "[]";
      } else {
        const { _o_type, _o_classes } = jsonSerializableParser(
          _variable_name,
          value[0]
        );
        _type = `List<${_o_type}>`;
        _default = "[]";
        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
        }
      }
    } else {
      _type = _class_name;

      _default = `${_class_name}.Builder().build()`;
      let _o_class = `@JsonSerializable(nullable: false,explicitToJson: true)\nclass ${_class_name} {\n`;

      let _o_builder_defaults = "";
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const {
            _o_type,
            _o_classes,
            _o_variable_name
          } = jsonSerializableParser(key, data);
          const { _class, _builder } = to_json_serializable_var(
            key,
            _o_variable_name,
            _o_type,
            false
          );
          _o_class += _class;
          // _o_builder += _builder;
          _o_builder_defaults += `${_o_builder_defaults ? "," : ""}${_builder}`;
          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
          }
        }
      }

      _classes.push(
        `${_o_class}\n\n\t${_class_name}({${_o_builder_defaults}});\n\n\tfactory ${_class_name}.fromJson(Map<String, dynamic> json) => _$${_class_name}FromJson(json);\n\n\tMap<String, dynamic> toJson() => _$${_class_name}ToJson(this);\n\n}`.replace(
          /\n\s*\n/g,
          "\n"
        )
      );
    }
  }

  return {
    _o_type: _type,
    _o_default: _default,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)]
  };
}
